import Timestamp from "components/Timestamp";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import Typography from "ds/components/Typography";
import Card from "ds/components/Card";

import { useAccountDeletion } from "../useAccountDeletion";
import { showMarkForDeletionModal } from "../MarkForDeletionModal";
import { showDeleteConfirmationModal } from "../DeleteConfirmationModal";

const AccountDeletionCard = () => {
  const {
    isAccountDeletionAvailable,
    markedForDeletion,
    accountCanBeDeleted,
    accountCanBeDeletedAt,
    toggleForDeletionMark,
    loadingMarking,
  } = useAccountDeletion();

  const handleMarkForDeletion = () => {
    showMarkForDeletionModal();
  };

  const handleDelete = () => {
    showDeleteConfirmationModal();
  };

  if (!isAccountDeletionAvailable) {
    return null;
  }

  if (markedForDeletion) {
    return (
      <Card
        title="Delete account"
        headerSuffix={
          <Box direction="row" gap="small">
            <Button
              variant="secondary"
              size="small"
              onPress={toggleForDeletionMark}
              loading={loadingMarking}
              disabled={loadingMarking}
            >
              Do not delete
            </Button>
            {accountCanBeDeleted && (
              <Button variant="dangerPrimary" size="small" onPress={handleDelete}>
                Delete
              </Button>
            )}
          </Box>
        }
      >
        <Typography variant="p-body3" tag="p">
          {accountCanBeDeleted && (
            <>
              Permanently delete this account, including all users and resources. This action is
              irreversible.
            </>
          )}
          {!accountCanBeDeleted && accountCanBeDeletedAt && (
            <>
              This account is pending deletion. Run creation is blocked. Deletion will be available
              on <Timestamp timestamp={accountCanBeDeletedAt} variant="p-t7" />. You may cancel at
              any time.
            </>
          )}
        </Typography>
      </Card>
    );
  }

  return (
    <Card
      title="Delete account"
      headerSuffix={
        <Button variant="dangerPrimary" size="small" onPress={handleMarkForDeletion}>
          Mark for deletion
        </Button>
      }
    >
      <Typography variant="p-body3" tag="p">
        Marks this account for deletion. Run creation will be disabled immediately. After 7 days,
        you can permanently delete all user accounts and resources.
      </Typography>
    </Card>
  );
};

export default AccountDeletionCard;
